import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import PartnerTaskActions from 'client/actions/PartnerTask';
import SrPartnerTaskListRow from 'client/components/SrPartnerTaskList/SrPartnerTaskListRow';

import './SrPriceMarketFitSunSpotPartnerTask.less';

const SrPriceMarketFitSunSpotPartnerTask = ({
  className,
  dispatch,
  partnerTask,
  currentUser,
  listing,
}) => {
  return (
    <div styleName={classnames('cardBox', className)}>
      <span styleName="title">Recommended Task</span>
      <div styleName="taskBox">
        <SrPartnerTaskListRow
          task={partnerTask}
          updatePartnerTask={() => {
            dispatch(PartnerTaskActions.getList, {
              listingId: listing.id,
            });
          }}
          currentUser={currentUser}
        />
      </div>
    </div>
  );
};

SrPriceMarketFitSunSpotPartnerTask.propTypes = {
  className: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  partnerTask: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
};

export default SrPriceMarketFitSunSpotPartnerTask;
